(ns manage.resource.script
  (:require [common.url-template :as url-tpl]
            [re-frame.core :as rf]))

(rf/reg-event-fx :resource.script/post
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [url-context] :as cofx} [_ payload]]
    {:http
     {:method     :post
      :params     payload
      :uri        (url-tpl/render :api/advertiser-pixels url-context)
      :headers    {"Authorization" (:resource.user/token cofx)}
      :on-success [:resource.script/post-success]
      :on-failure [:resource.script/post-failure]}}))

(rf/reg-event-db :resource.script/post-success
  (fn [db]
    db))

(rf/reg-event-db :resource.script/post-failure
  (fn [db] db))

(rf/reg-event-fx :resource.script/put
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [url-context] :as cofx} [_ payload]]
    {:http
     {:method     :put
      :params     payload
      :uri        (url-tpl/render :api/advertiser-pixel (assoc url-context :pixel-id (:id payload)))
      :headers    {"Authorization" (:resource.user/token cofx)}
      :on-success [:resource.script/put-success]
      :on-failure [:resource.script/put-failure]}}))

(rf/reg-event-db :resource.script/put-success
  (fn [db]
    db))

(rf/reg-event-db :resource.script/put-failure
  (fn [db]
    db))

(rf/reg-event-fx :resource.script/get-script
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [url-context] :as cofx} [_ id]]
    {:http
     {:method          :get
      :uri             (url-tpl/render :api/advertiser-pixel-script (assoc url-context :pixel-id id))
      :headers         {"Content-Type"  "text/plain"
                        "Authorization" (:resource.user/token cofx)}
      :response-format :text
      :on-success      [:resource.script/get-script-success]
      :on-failure      [:resource.script/get-script-failure]}}))

(rf/reg-event-db :resource.script/get-script-success
  (fn [db [_ _r]]
    db))

(rf/reg-event-db :resource.script/get-script-failure
  (fn [db [_ _r]]
    db))

(rf/reg-event-fx :resource.script/delete
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [url-context] :as cofx} [_ id]]
    {:http
     {:method     :delete
      :uri        (url-tpl/render :api/advertiser-pixel (assoc url-context :pixel-id id))
      :headers    {"Authorization" (:resource.user/token cofx)}
      :on-success [:resource.script/delete-success]
      :on-failure [:resource.script/delete-failure]}}))

(rf/reg-event-db :resource.script/delete-success
  (fn [db]
    db))

(rf/reg-event-db :resource.script/delete-failure
  (fn [db]
    db))
